import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import TopicMenu from "../menu/TopicMenu";
import NavBar from "../navbar/Navbar";
import SideBar from "../sidebar/Sidebar";
import { Alert, App, Layout } from "antd";

import { ConfigProvider } from "antd";

import axios from "axios";
import { API_URL, lastDoc } from "../../constants";
import MonthBlockLine from "../navbar/MonthBlockLine";
// import LUC from "../content/LUC";

const Main = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentUser = useSelector((state) => state.user.currentUser);
  const topics = [
    // { name: "Indici", key: "indici" },
    // { name: "Plati", key: "plati" },
    { name: "Tarif", key: "tarif" },
    { name: "Banci", key: "banci" },
    { name: "Documente diverse", key: "docs" },
    { name: "Utilizatori", key: "users" },
    { name: "Backup-uri", key: "backup-uri" },
    { name: "Calculari", key: "calculari" },
    { name: "Facturi", key: "facturi" },
    // { name: "LUC", content: <LUC /> },
  ];
  const [selectedKey, setSelectedKey] = useState("indice");
  const [showAlrert, setShowAlrert] = useState(false);
  const getBlockStatusClientIndici = async () => {
    try {
      const res = await axios.get(
        API_URL + "user/gestionar/client/blockageStatus"
      );
      const res2 = await lastDoc();
      if (res.data.blocked) {
        let idiceObject = res2.data.find((item) => item.type === "indice");
        //Add code here
        if (idiceObject) {
          const createdAt = new Date(idiceObject.createdAt);
          const now = new Date();

          const isSameMonth =
            createdAt.getFullYear() === now.getFullYear() &&
            createdAt.getMonth() === now.getMonth();

          if (isSameMonth) {
            setShowAlrert(true);
          }
        }
      }
      console.log(res, res2);
    } catch (error) {
      console.log({ error });
    }
  };
  useEffect(() => {
    getBlockStatusClientIndici();
  }, []);

  useEffect(() => {
    if (currentUser?.role === "admin") {
      const key = pathname.split("/").at(-1);
      console.log({ key });
      setSelectedKey(key);
    } else {
      navigate("/login");
      sessionStorage.clear();
    }
  }, [pathname, currentUser]);

  const Menu = <TopicMenu topics={topics} selectedKey={selectedKey} />;

  const token = {
    colorPrimary: "#008ddb",
  };
  const stagingClass =
    process.env.REACT_APP_SERVER_ENV !== "production" ? "staging-env" : "";

  return (
    <div className={`App ${stagingClass}`}>
      <ConfigProvider
        theme={{ token, components: { Button: { dangerColor: "#FF0000" } } }}
      >
        <App>
          <MonthBlockLine />
          <NavBar menu={Menu} />
          <Layout>
            <SideBar menu={Menu} />
            <Layout.Content className="content">
              {/*{showAlrert && (<Alert message="În cursul acestei luni a fost încărcat fișierul cu indici, iar accesul la introducerea indicilor de consum pentru consumatorii casnici este restricționat. Vă rugăm respectuos să activați drepturile necesare în vederea transmiterii indicilor de către consumatorii casnici." type="error" style={{marginBottom: "10px"}} />)}*/}
              {showAlrert && (
                <Alert
                  description={
                    <>
                      Fișierul cu indicii a fost încărcat cu succes. Puteți
                      activa funcționalitatea de introducere a indicilor pe
                      platforma{" "}
                      <b>
                        <a href={"https://invoicer.md"} target={"_blank"}>
                          invoicer.md
                        </a>
                      </b>{" "}
                      și debloca opțiunea de modificare a acestora în aplicația
                      gestionarului.
                    </>
                  }
                  type="error"
                  style={{ marginBottom: "10px" }}
                />
              )}
              {/* {topics[contentIndex]?.content} */}
              {children}
            </Layout.Content>
          </Layout>
        </App>
      </ConfigProvider>
    </div>
  );
};

export default Main;
